/* eslint-disable react-hooks/exhaustive-deps */
import { XIcon } from "@heroicons/react/solid";
import { openDB } from "idb";
import React, { useContext, useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import Context from "../context/context";
let seat_num = 0;

export default function NewSeat({
  close,
  type,
  value,
  id,
  getNewSeatAdded,
  setIsSeatModified,
  isNewSeatAdded,
  setIsNewSeatAdded,
}) {
  const [seats, setSeats] = useState([]);
  const [sections, setSections] = useState([]);

  const [seatDetail, setSeatDetail] = useState({});
  const context = useContext(Context);
  const { updateUnSync } = context;

  //Fetching all the existing seats and sections form indexDB
  useEffect(() => {
    const getDataFromIndexdDb = async () => {
      const db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );

      //Fetching all the existing sections form indexDB
      const indSections = await db
        .transaction("outlet", "readonly")
        .objectStore("outlet");
      const currentSections = await indSections.getAll();
      setSections(currentSections[0].section_details);

      //Fetching all the existing seats form indexDB
      const indSeats = await db
        .transaction("seats", "readonly")
        .objectStore("seats");
      const currentSeats = await indSeats.getAll();
      setSeats(currentSeats);
    };
    getDataFromIndexdDb();
  }, [isNewSeatAdded]);
  useEffect(
    () =>
      setSeatDetail({
        seat_name: type === "New" ? "" : value.seat_name,
        seat_sort_order: type === "New" ? 1 : `${value.seat_sort_order}`,
        seat_status: type === "New" ? "1" : `${value.seat_status}`,
        section_uuid:
          type === "New"
            ? sections.length
              ? sections[0]?.section_uuid
              : []
            : value.section_uuid,
      }),
    [sections]
  );
  // Adding new seat to seats collection in IndexedDB
  const handleAddSeat = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("seats", "readwrite")
      .objectStore("seats");
    const id = uuid();
    if (
      seats.filter((sea) => sea.section_uuid === seatDetail.section_uuid)
        .length > 0
    ) {
      let x = seats.filter(
        (set) => set.section_uuid === seatDetail.section_uuid
      );

      function compare(a, b) {
        if (a.seat_sort_order < b.seat_sort_order) {
          return -1;
        }
        if (a.seat_sort_order > b.seat_sort_order) {
          return 1;
        }
        return 0;
      }

      x = x.sort(compare);

      if (x && x?.length) {
        seat_num = x[x.length - 1].seat_sort_order;
      }

      const data = {
        IDENTIFIER: id,
        seat_uuid: id,
        seat_name: seatDetail.seat_name,
        outlet_uuid: localStorage.getItem("outlet_uuid"),
        seat_sort_order: `${parseInt(seat_num) + 1}`,
        seat_status: seatDetail.seat_status,
        section_uuid: seatDetail.section_uuid,
        menu_details: [],
      };

      await indSeats.put(data);
      handleAddSeatUnsynced(data);
      close();
    } else {
      let id = uuid();
      const data = {
        IDENTIFIER: id,
        seat_uuid: id,
        seat_name: seatDetail.seat_name,
        seat_sort_order: `${parseInt(seat_num) + 1}`,
        outlet_uuid: localStorage.getItem("outlet_uuid"),
        seat_status: seatDetail.seat_status,
        section_uuid: seatDetail.section_uuid,
      };
      await indSeats.put(data);
      handleAddSeatUnsynced(data);
      close();
    }
    setIsNewSeatAdded(id);
  };

  // Editing existing seat in seats collection in IndexedDB
  const handleEditSeat = async () => {
    const id = uuid();
    setIsSeatModified(id);
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("seats", "readwrite")
      .objectStore("seats");
    const tx = await indSeats.get(`${value.seat_uuid}`);

    const data = {
      ...tx,
      seat_name: seatDetail.seat_name,
      section_uuid: seatDetail.section_uuid,
      seat_status: seatDetail.seat_status,
    };
    await indSeats.put(data);
    handleEditSeatUnsynced(data);
    close();
  };

  // Adding new added seat to unsynced_files collection in IndexedDB
  const handleAddSeatUnsynced = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "seat-new:" + data.seat_uuid,
    };
    await tx.put(ndata);
    handleReconciliation(ndata);
    updateUnSync();
  };

  // Editing existing seat in unsynced_files collection in IndexedDB
  const handleEditSeatUnsynced = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "seat-edit:" + data.seat_uuid,
    };
    await tx.put(ndata);
    handleReconciliation(ndata);
    updateUnSync();
  };

  // Adding seat in reconciliation collection in IndexedDB
  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const seatsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "seat"
    );
    if (seatsJsonExists) {
      const seats = seatsJsonExists?.details?.filter(
        (seat) => seat.seat_uuid !== data.seat_uuid
      );
      const editData = {
        ...seatsJsonExists,
        details: [
          ...seats,
          {
            seat_uuid: data.seat_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "seat",
        details: [
          {
            seat_uuid: data.seat_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  return (
    <div
      className='newCategory'
      draggable={false}
      onKeyDown={(e) =>
        e.key === "Enter" && seatDetail.seat_name !== ""
          ? type === "New"
            ? handleAddSeat()
            : handleEditSeat()
          : document.getElementById("catname").focus()
      }>
      <div className='newCatContainer'>
        <div className='newCatContainer_header'>
          <h2>Seat</h2>
          <XIcon className='closeicon' onClick={close} />
        </div>
        <div className='newCatContainer2'>
          <div className='cat-inp'>
            <label htmlFor='catname'>Seat Name</label>
            <input
              value={seatDetail.seat_name}
              onChange={(e) =>
                setSeatDetail({ ...seatDetail, seat_name: e.target.value })
              }
              maxLength={15}
              type='text'
              id='catname'
            />
          </div>
          <div className='cat-inp'>
            <label htmlFor='catstatus'>Section</label>
            <select
              value={seatDetail.section_uuid}
              onChange={(e) =>
                setSeatDetail({ ...seatDetail, section_uuid: e.target.value })
              }
              id='catstatus'>
              {sections.map((section, i) => (
                <option value={section.section_uuid} key={i}>
                  {section.section_name}
                </option>
              ))}
            </select>
          </div>
          <div className='cat-inp'>
            <label htmlFor='catstatus'>Seat Status</label>
            <select
              id='catstatus'
              value={seatDetail.seat_status}
              onChange={(e) =>
                setSeatDetail({ ...seatDetail, seat_status: e.target.value })
              }>
              <option value='1'>Enabled</option>
              <option value='0'>Disabled</option>
            </select>
          </div>
          {type === "New" ? (
            <button onClick={seatDetail.seat_name !== "" ? handleAddSeat : ""}>
              Save
            </button>
          ) : (
            <button onClick={seatDetail.seat_name !== "" ? handleEditSeat : ""}>
              Update
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
